// extracted by mini-css-extract-plugin
export default {"root":"AgencyApprovalCard_root__omxLD","displayHeader":"AgencyApprovalCard_displayHeader__XHh4y"};